// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Jr","image":"e_Kr","imageImage":"e_Lr","description":"e_Mr","title":"e_Nr","button":"e_Or"};